/**
 * G-143 — each shop's colour on the web-orders report. The slot follows the
 * shop, never its rank: shops are ordered by code once, so Còrsega keeps its
 * colour whether it took the most orders this month or the fewest. Six
 * validated `--chart-N` tokens (tokens.css); a seventh shop and beyond, and
 * the orders no shop took, use `--chart-other`.
 */
export type ShopColorSlot = "1" | "2" | "3" | "4" | "5" | "6" | "other";

const SLOT_COUNT = 6;

export function shopColorSlots(shops: readonly { id: string; code: string }[]): Map<string, ShopColorSlot> {
  const ordered = [...shops].sort((a, b) => a.code.localeCompare(b.code) || a.id.localeCompare(b.id));
  return new Map(
    ordered.map((shop, index) => [
      shop.id,
      index < SLOT_COUNT ? (String(index + 1) as ShopColorSlot) : "other",
    ]),
  );
}
